export const GENERIC_EMAIL_SERVICE_SUCCESS = 'GENERIC_EMAIL_SERVICE_SUCCESS';
export const GENERIC_EMAIL_SERVICE_ERROR = 'GENERIC_EMAIL_SERVICE_ERROR';
export const SAVE_GENERIC_EMAIL_VALIDATION = 'SAVE_GENERIC_EMAIL_VALIDATION';
export const RESET_GENERIC_EMAIL_SUCCESS_STATE = 'RESET_GENERIC_EMAIL_SUCCESS_STATE';

export function genericEmailServiceSuccess() {
    return {
        type: GENERIC_EMAIL_SERVICE_SUCCESS
    };
}

export function genericEmailServiceError(error) {
    return {
        type: GENERIC_EMAIL_SERVICE_ERROR,
        error: true,
        payload: {
            response: error
        }
    };
}

export function saveGenericEmailValidation(values, msgs) {
    return {
        type: SAVE_GENERIC_EMAIL_VALIDATION,
        payload: {
            values: values,
            msgs: msgs
        }
    };
}

export function resetGenericEmailSuccessState() {
    return {
        type: RESET_GENERIC_EMAIL_SUCCESS_STATE
    };
}
